var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCrystal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 31,
    viewBox: "0 0 38 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.67635 0C8.23839 3.68379e-05 7.82263 0.191823 7.53768 0.524414L0.433189 8.81738C-0.154513 9.50347 -0.143059 10.5193 0.460533 11.1914L17.6129 30.291C18.3183 31.0761 19.5492 31.0762 20.2545 30.291L37.4078 11.1914C38.0114 10.5193 38.0237 9.50346 37.4361 8.81738L30.3297 0.523438L30.2164 0.40625C29.94 0.146947 29.574 0.00016246 29.191 0H8.67635ZM18.9107 28.9336L14.5279 10.5205H23.2926L18.9107 28.9336ZM20.8385 27.6943L30.8473 10.502H36.2799L20.8385 27.6943ZM16.898 27.5488L1.58944 10.502H6.97323L16.898 27.5488ZM30.5113 10.3672H23.8189L20.7115 1.2998H26.2183L30.5113 10.3672ZM14.0015 10.3672H7.30917L11.6021 1.2998H17.109L14.0015 10.3672Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrystal);
export default __webpack_public_path__ + "static/media/icon-crystal.579c545bd223adfa7db6d191354a696e.svg";
export { ForwardRef as ReactComponent };